/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListStaffAndInvitationsQueryResponse, ListStaffAndInvitationsPathParams, ListStaffAndInvitationsQueryParams, ListStaffAndInvitations400, ListStaffAndInvitations401, ListStaffAndInvitations403, ListStaffAndInvitations404, ListStaffAndInvitations409, ListStaffAndInvitations500 } from "../../types/staffController/ListStaffAndInvitations.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listStaffAndInvitations } from "../../client/staffController/listStaffAndInvitations.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listStaffAndInvitationsQueryKey = (organizationId: ListStaffAndInvitationsPathParams["organizationId"] | undefined, params?: ListStaffAndInvitationsQueryParams) => [{ url: '/api/organizations/:organizationId/staff-and-invitations', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListStaffAndInvitationsQueryKey = ReturnType<typeof listStaffAndInvitationsQueryKey>

export function listStaffAndInvitationsQueryOptions(organizationId: ListStaffAndInvitationsPathParams["organizationId"] | undefined, params?: ListStaffAndInvitationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listStaffAndInvitationsQueryKey(organizationId, params)
        return queryOptions<ListStaffAndInvitationsQueryResponse, ResponseErrorConfig<ListStaffAndInvitations400 | ListStaffAndInvitations401 | ListStaffAndInvitations403 | ListStaffAndInvitations404 | ListStaffAndInvitations409 | ListStaffAndInvitations500>, ListStaffAndInvitationsQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listStaffAndInvitations(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List staff and invitations
 * {@link /api/organizations/:organizationId/staff-and-invitations}
 */
export function useListStaffAndInvitations<TData = ListStaffAndInvitationsQueryResponse, TQueryData = ListStaffAndInvitationsQueryResponse, TQueryKey extends QueryKey = ListStaffAndInvitationsQueryKey>(organizationId: ListStaffAndInvitationsPathParams["organizationId"] | undefined, params?: ListStaffAndInvitationsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListStaffAndInvitationsQueryResponse, ResponseErrorConfig<ListStaffAndInvitations400 | ListStaffAndInvitations401 | ListStaffAndInvitations403 | ListStaffAndInvitations404 | ListStaffAndInvitations409 | ListStaffAndInvitations500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listStaffAndInvitationsQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listStaffAndInvitationsQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListStaffAndInvitations400 | ListStaffAndInvitations401 | ListStaffAndInvitations403 | ListStaffAndInvitations404 | ListStaffAndInvitations409 | ListStaffAndInvitations500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}